import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import {
	Button,
	Dialog,
	DialogClose,
	DialogContent,
	DialogFooter,
	DialogOverlay,
} from '@/app/shared/components';
// import { useCustomSelector } from '@/core/redux/hooks';

interface ExchangeDiamondsConfirmedProps {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
	shurikens: string;
	diamonds: number;
}

export const ExchangeDiamondsConfirmed: React.FC<
	ExchangeDiamondsConfirmedProps
> = ({
	isOpen,
	onClose,
	shurikens,
	diamonds,
}: ExchangeDiamondsConfirmedProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Redux
	**********************/

	/*********************
	// #region Constants
	**********************/
	/*********************
	// #region Functions  
	**********************/
	const handleCloseDialog = () => {
		onClose(false);
	};

	/*********************
	// #region Template
	**********************/
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogOverlay className="bg-customer-950/70" />
			<DialogContent
				className="border-none bg-transparent"
				overlayClassname="bg-customer-950/90"
			>
				<div className="flex flex-col items-center space-x-2">
					<img
						className="mx-auto my-6"
						src={process.env.VITE_LOT_OF_SHURIKENS_IMAGE}
					/>

					<p className="text-xl text-center font-bold">
						{t('hacks.exchangeDiamonds.textConfirmed', {
							shurikens,
							diamonds,
						})}
					</p>
				</div>
				<DialogFooter className="sm:justify-start">
					<DialogClose asChild>
						<Button
							type="button"
							variant="primary"
							onClick={handleCloseDialog}
							className="py-6 w-full flex items-center gap-1 text-sm rounded-lg"
						>
							{t('general.keepGoing')}
						</Button>
					</DialogClose>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
